import * as React from 'react';
import update from 'immutability-helper';
import { Button, Form, Input, Modal } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { BaseModal } from 'components/base-modal/component';
import { isEmailValid } from 'helpers/email-helper';

import './styles.css';

interface InnerState {
  userEmail: string;
}

export interface Props {
  showForgotPasswordModal: boolean;
  passwordResetSuccess: boolean;
  isProcessingPasswordReset: boolean;
  isPasswordResetRequested: boolean;
  hasEnterpriseLogin: boolean;
  passwordResetErrorMessage: string;
  resetPassword: (userEmail: string) => void;
  closeModal: () => void;
}

export class ForgotPasswordModal extends React.Component<Props, InnerState> {

  constructor(props: Props) {
    super(props);

    this.state = {
      userEmail: ''
    };
  }

  public render() {
    const i18n = getI18n();

    const enterprisePasswordReset = (
      <p className="enterprise-message">
        {i18n.t(translations.ForgotPasswordContactAdmin)}
      </p>
    );

    const managedPasswordReset = (
      <Form className="managed-form">
        <Form.Field className="useremail-field">
          <label className="form-label">{i18n.t(translations.Email)}</label>
          <Input name="Useremail" size="huge" className="email-input no-border-radius"
            value={this.state.userEmail} onChange={this.setUserEmail} onInput={this.setUserEmail} />
        </Form.Field>
        {
          !this.props.isProcessingPasswordReset && this.props.isPasswordResetRequested ?
            this.props.passwordResetSuccess
              ? <p className="pw-reset-success ui green message success-message">
                {i18n.t(translations.PasswordResetSuccess)}
              </p>
              : <p className="pw-reset-error ui red message error-message">
                {i18n.t(this.props.passwordResetErrorMessage)}
              </p>
            : ''
        }
      </Form>
    );

    const modalActionButton = this.props.hasEnterpriseLogin ? undefined : (
      <Button
        className="pw-reset-button"
        disabled={!isEmailValid(this.state.userEmail) || this.props.isProcessingPasswordReset}
        loading={this.props.isProcessingPasswordReset}
        onClick={this.sendResetPassword}>
        {i18n.t(translations.Submit)}
      </Button>
    );

    return (
      <BaseModal
        open={this.props.showForgotPasswordModal}
        modalProps={{ size: 'small', className: 'forgot-password-modal' }}
        headerText={i18n.t(translations.ForgotPassword)}
        showHeaderClose={true}
        closeHandler={this.props.closeModal}
        actionButton={modalActionButton}
      >
        <Modal.Description>
          {
            this.props.hasEnterpriseLogin ? enterprisePasswordReset : managedPasswordReset
          }
        </Modal.Description>
      </BaseModal>
    );
  }

  private sendResetPassword = () => {
    this.props.resetPassword(this.state.userEmail);
  }

  private setUserEmail = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState(update(this.state, {
      userEmail: { $set: event.currentTarget.value }
    }));
  }
}


// WEBPACK FOOTER //
// ./src/pages/login/forgot-password-modal.tsx